import React from 'react';

import classes from './Testimonials.css';

const testimonials = (props) => {
    return (
        <div className={classes.Testimonials} style={props.style}>
            <div className={classes.Content} style={{float: "left"}}>&ldquo; Very good balance of management and technical skill &rdquo;</div>
            <div className={classes.Content} style={{float: "right"}}>&ldquo; Their keen interest to new technologies,Agile methodology,Scrum management and visualization of big picture sets RiseUp apart from the crowd &rdquo;</div>
            <div className={classes.Content} style={{float: "left"}}>&ldquo; RiseUp puts the right strategy and energy to bring up a transparent discussion on to the table and integrating coherent pieces which helps creating a delivery focused motivated team and also results well in stakeholder management and risk mitigation &rdquo;</div>
            <div className={classes.Content} style={{float: "right"}}>&ldquo; Really hard worker with great human and technical skills particularly concerning Microsoft .Net &rdquo;</div>    
        </div>

    );
}

export default testimonials;


// WEBPACK FOOTER //
// ./client/src/components/Testimonials/Testimonials.js